import { Component } from '@angular/core';

@Component({
    selector: 'app-blog-unlock-pdf',
    imports: [],
    templateUrl: './blog-unlock-pdf.component.html',
    styleUrl: './blog-unlock-pdf.component.css'
})
export class BlogUnlockPdfComponent {

}
